import { RouterLink } from '@/navigation';
import { Typography, TypographyProps } from '@mui/material';
interface Props extends TypographyProps {
  sku?: string;
  maxLine?: number;
}

export const ProductTitle: React.FC<Props> = ({
  children,
  maxLine = 2,
  sx,
  title,
  sku,
  className,
  ...rest
}) => {
  const typographyElement = (
    <Typography
      variant="h5"
      sx={{
        color: 'secondary.dark',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: maxLine,
        WebkitBoxOrient: 'vertical',
        marginBottom: 0,
        ...sx,
      }}
      title={title}
      {...rest}
    >
      {children ? (
        children
      ) : (
        <span
          dangerouslySetInnerHTML={{
            // Product titles typically include HTML character entities for registered, TM, etc.
            __html: title ?? '',
          }}
        />
      )}
    </Typography>
  );

  return sku ? (
    <RouterLink style={{ textDecoration: 'none' }} className={className} href={`/products/${sku}`}>
      {typographyElement}
    </RouterLink>
  ) : (
    typographyElement
  );
};
